import locationSearchAdapterMethods from './locationSearchAdapterMethods';
import { getLocationObjectId } from '../common/locationSearchClient';

export default {
    data() {
        return {
            previousPickupLocationId: null,
            dropoffLocations: [],
            locationSearchAdapter: null,
        };
    },

    watch: {
        pickupLocation(location) {
            if (location === null || location.provider === 'CTR') {
                return this.$store.dispatch('setDropoffLocation', null);
            }

            if (location.dropoff_locations) {
                let locations = location.dropoff_locations.locations.slice(0);

                if (locations.length <= 1 && locations[0] === location.id) {
                    return;
                }

                locations.unshift(location.id);
                this.getLocationSearchAdapter()
                    .getObjects(locations.map((locationId) => getLocationObjectId(locationId, this.searchOptions)))
                    .then((content) => {
                        this.$store.dispatch('setDropoffDifferent', true);
                        this.dropoffLocations = content;
                    })
                    .catch((err) => {
                        console.error(err);
                        this.dropoffLocations = [];
                    });

                // Keep the dropoff location for one-way quotes when updating the dates.
                // Should check that previous pickup location has not changed,
                // and if it has changed, then do not keep the dropoff location and continue to set the new one
                if (this.dropoffLocation && this.previousPickupLocationId === location.id) {
                    this.$store.dispatch('setDropoffLocation', this.dropoffLocation);
                    return;
                }

                // Set the previous pickup location to check if the dropoff location should remain as is
                // or change on subsequent pickup changes
                this.previousPickupLocationId = location.id;

                this.$store.dispatch('setDropoffLocation', location);
            }
        },
    },

    methods: Object.assign({}, locationSearchAdapterMethods, {
        updateDropoffLocation(e) {
            this.dropoffLocations.map((locationItem) => {
                if (locationItem.id == e.target.value) {
                    this.$store.dispatch('setDropoffLocation', locationItem);
                }
            });
        },
    }),
};
